<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="shiftData"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div class="font-weight-bold">{{ name }}</div>
        </template>
        <template slot="code" slot-scope="code">
          <div>{{ code }}</div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{ description }}</div>
        </template>
        <template slot="start_time" slot-scope="start_time">
          <div>{{ start_time }}</div>
        </template>
        <template slot="break_start" slot-scope="break_start">
        <div>{{ break_start }}</div>
        </template>
        <template slot="break_end" slot-scope="break_end">
        <div>{{ break_end }}</div>
        </template>
        <template slot="end_time" slot-scope="end_time">
          <div>{{ end_time }}</div>
        </template>
        <template slot="is_default" slot-scope="is_default">
        <span>{{ is_default === 1 ? 'Yes' : 'No' }}</span>
        </template>
        <template slot="status" slot-scope="status">
          <a-tag :color="status === 1 ? 'green' : 'red'">
            {{ status === 1 ? 'Active' : 'Inactive' }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a
              href="javascript:;"
              v-if="rolesetting.editable"
              class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon"><i class="btn-addon-icon fe fe-edit" /></span>
              Edit
            </a>

            <!-- Delete -->
            <a
              href="javascript:;"
              v-if="rolesetting.deletable"
              class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon"><i class="btn-addon-icon fe fe-trash" /></span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-shift ref="editShift" @edited="handleEdited" />
  </div>
</template>

<script>
import EditShift from '@/components/shift/Forms/Edit/index'

const columns = [
  { title: 'Name', dataIndex: 'name', width: 120, scopedSlots: { customRender: 'name' } },
  { title: 'Code', dataIndex: 'code', width: 100, scopedSlots: { customRender: 'code' } },
  { title: 'Description', dataIndex: 'description', width: 200, scopedSlots: { customRender: 'description' } },
  { title: 'Start Time', dataIndex: 'start_time', width: 120, scopedSlots: { customRender: 'start_time' } },
  { title: 'Break Start', dataIndex: 'break_start', width: 120, scopedSlots: { customRender: 'break_start' } },
  { title: 'Break End', dataIndex: 'break_end', width: 120, scopedSlots: { customRender: 'break_end' } },
  { title: 'End Time', dataIndex: 'end_time', width: 120, scopedSlots: { customRender: 'end_time' } },
  { title: 'Default', dataIndex: 'is_default', width: 100, scopedSlots: { customRender: 'is_default' } },
  { title: 'Status', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
  { title: 'Actions', dataIndex: 'action', width: 150, scopedSlots: { customRender: 'action' }, className: 'text-right' },
]

export default {
  name: 'ShiftsTable',
  components: { EditShift },
  props: {
    select: Boolean,
    loading: Boolean,
    shiftData: { type: Array, default: () => [] },
    rolesetting: { type: Object },
  },
  data() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect() {
      if (!this.select) return null
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal(record) {
      this.$eventBus.$emit('openShiftEditModal', record.id)
    },
    handleEdited() {
      this.$emit('updateTable')
    },
    onDelete(record) {
      this.$confirm({
        title: 'Are you sure delete this shift?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/attendance-shift/single/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
      })
    },
  },
}
</script>
